import React, { useState, useEffect, useRef } from 'react';
import { Typography } from 'antd';

const MembershipNotifications = ({
  minInterval = 3000,
  maxInterval = 20000,
  displayDuration = 5000,
}) => {
  const [notifications, setNotifications] = useState([]);
  const notificationTimeouts = useRef({});
  const intervalRef = useRef(null);

  const MEMBERSHIP_DATA = [
    { name: 'Aarav Sharma' }, { name: 'Aditi Singh' }, { name: 'Advait Patel' },
    { name: 'Ananya Gupta' }, { name: 'Aryan Khan' }, { name: 'Avani Rao' },
    { name: 'Bharat Kumar' }, { name: 'Bhavya Reddy' }, { name: 'Chaitanya Verma' },
    { name: 'Deepika Padukone' }, { name: 'Devansh Joshi' }, { name: 'Diya Shah' },
    { name: 'Eklavya Choudhary' }, { name: 'Esha Sharma' }, { name: 'Farah Ali' },
    { name: 'Gaurav Singh' }, { name: 'Gayatri Iyer' }, { name: 'Harsh Varma' },
    { name: 'Ishita Desai' }, { name: 'Jai Mehta' }, { name: 'Jhanvi Kapoor' },
    { name: 'Kabir Singh' }, { name: 'Kavya Rao' }, { name: 'Lakshya Kumar' },
    { name: 'Lavanya Menon' }, { name: 'Maanav Sharma' }, { name: 'Mahi Khan' },
    { name: 'Naman Gupta' }, { name: 'Naina Singh' }, { name: 'Om Prakash' },
    { name: 'Palak Agarwal' }, { name: 'Pranav Sharma' }, { name: 'Priya Singh' },
    { name: 'Raghav Singh' }, { name: 'Rhea Chakraborty' }, { name: 'Rohan Mehta' },
    { name: 'Roshni Patel' }, { name: 'Samar Jain' }, { name: 'Sara Khan' },
    { name: 'Shaurya Singh' }, { name: 'Shreya Sharma' }, { name: 'Siddharth Malhotra' },
    { name: 'Siya Sharma' }, { name: 'Tanay Shah' }, { name: 'Tanisha Gupta' },
    { name: 'Uday Kumar' }, { name: 'Uma Sharma' }, { name: 'Vaibhav Singh' },
    { name: 'Vani Reddy' }, { name: 'Vivaan Shah' }, { name: 'Zara Khan' },
    { name: 'Aarushi Sharma' }, { name: 'Abhinav Singh' }, { name: 'Akanksha Gupta' },
    { name: 'Akhil Kumar' }, { name: 'Amara Singh' }, { name: 'Anand Rao' },
    { name: 'Anika Sharma' }, { name: 'Arjun Singh' }, { name: 'Asha Devi' },
    { name: 'Ashish Kumar' }, { name: 'Avani Sharma' }, { name: 'Ayush Gupta' },
    { name: 'Bhumika Singh' }, { name: 'Chirag Patel' }, { name: 'Damini Sharma' },
    { name: 'Darsh Singh' }, { name: 'Devina Gupta' }, { name: 'Dhruv Sharma' },
    { name: 'Disha Singh' }, { name: 'Divya Sharma' }, { name: 'Ekansh Kumar' },
    { name: 'Esha Singh' }, { name: 'Falguni Patel' }, { name: 'Gagan Sharma' },
    { name: 'Geeta Devi' }, { name: 'Girish Kumar' }, { name: 'Harshita Singh' },
    { name: 'Hina Khan' }, { name: 'Idris Ali' }, { name: 'Indu Sharma' },
    { name: 'Ishaan Singh' }, { name: 'Jaya Devi' }, { name: 'Jatin Kumar' },
    { name: 'Juhi Chawla' }, { name: 'Karan Singh' }, { name: 'Kirti Sharma' },
    { name: 'Krish Gupta' }, { name: 'Kusum Devi' }, { name: 'Lakshmi Singh' },
    { name: 'Lata Devi' }, { name: 'Manoj Kumar' }, { name: 'Meera Singh' },
    { name: 'Mohit Sharma' }, { name: 'Monica Devi' }, { name: 'Naveen Kumar' },
    { name: 'Nidhi Sharma' }, { name: 'Nikhil Singh' }, { name: 'Nikita Gupta' },
    { name: 'Ojas Sharma' }, { name: 'Pooja Devi' }, { name: 'Prashant Kumar' },
    { name: 'Preeti Singh' }, { name: 'Rahul Sharma' }, { name: 'Rajesh Kumar' },
    { name: 'Rakesh Singh' }, { name: 'Rama Devi' }, { name: 'Ranjit Kumar' },
    { name: 'Rashmi Sharma' }, { name: 'Ravi Singh' }, { name: 'Reena Devi' },
    { name: 'Ritika Sharma' }, { name: 'Rohit Singh' }, { name: 'Ruchika Gupta' },
    { name: 'Sagar Kumar' }, { name: 'Sanjana Singh' }, { name: 'Sanjay Kumar' },
    { name: 'Sarita Devi' }, { name: 'Satish Sharma' }, { name: 'Seema Devi' },
    { name: 'Sharad Kumar' }, { name: 'Shekhar Singh' }, { name: 'Shruti Sharma' },
    { name: 'Sita Devi' }, { name: 'Sonali Gupta' }, { name: 'Subhash Kumar' },
    { name: 'Sujata Singh' }, { name: 'Sunil Sharma' }, { name: 'Surekha Devi' },
    { name: 'Suresh Kumar' }, { name: 'Swati Sharma' }, { name: 'Tarun Singh' },
    { name: 'Tejaswini Devi' }, { name: 'Uma Devi' }, { name: 'Utkarsh Sharma' },
    { name: 'Varun Singh' }, { name: 'Veena Devi' }, { name: 'Vikas Kumar' },
    { name: 'Vinay Sharma' }, { name: 'Vishal Singh' }, { name: 'Yamini Devi' },
    { name: 'Yash Sharma' }, { name: 'Yogesh Kumar' }, { name: 'Aisha Khan' },
    { name: 'Akash Kumar' }, { name: 'Alisha Singh' }, { name: 'Amit Sharma' },
    { name: 'Anjali Gupta' }, { name: 'Ankit Singh' }, { name: 'Anurag Kumar' },
    { name: 'Aparna Devi' }, { name: 'Arjun Reddy' }, { name: 'Ashwini Sharma' },
    { name: 'Avinash Singh' }, { name: 'Chandni Patel' }, { name: 'Dinesh Kumar' },
    { name: 'Garima Singh' }, { name: 'Gaurav Kumar' }, { name: 'Himanshu Sharma' },
    { name: 'Jyoti Devi' }, { name: 'Kajal Gupta' }, { name: 'Kamal Singh' },
    { name: 'Kiran Devi' }, { name: 'Laxman Kumar' }, { name: 'Madhuri Sharma' },
    { name: 'Manish Singh' }, { name: 'Maya Devi' }, { name: 'Mehul Patel' },
    { name: 'Namita Sharma' }, { name: 'Neha Singh' }, { name: 'Nitish Kumar' },
    { name: 'Pankaj Sharma' }, { name: 'Poonam Devi' }, { name: 'Prakash Singh' },
    { name: 'Puja Sharma' }, { name: 'Rajeshwari Devi' }, { name: 'Ravi Prakash' },
    { name: 'Rekha Singh' }, { name: 'Rina Devi' }, { name: 'Ritesh Kumar' },
    { name: 'Roopa Sharma' }, { name: 'Sadhana Devi' }, { name: 'Sameer Singh' },
    { name: 'Sandhya Devi' }, { name: 'Sanjay Gupta' }, { name: 'Sarika Singh' },
    { name: 'Shivani Sharma' }, { name: 'Shweta Devi' }, { name: 'Sonal Singh' },
    { name: 'Sumit Sharma' }, { name: 'Sunita Devi' }, { name: 'Tanvi Singh' },
    { name: 'Urvashi Sharma' }, { name: 'Vandana Devi' }, { name: 'Vinita Singh' },
    { name: 'Vivek Sharma' }, { name: 'Aditya Kumar' }, { name: 'Amrita Singh' },
    { name: 'Aniket Sharma' }, { name: 'Aruna Devi' }, { name: 'Ashok Kumar' },
    { name: 'Deepak Singh' }, { name: 'Divyansh Sharma' }, { name: 'Gitanjali Devi' },
    { name: 'Harshita Kumar' }, { name: 'Ishita Singh' }, { name: 'Jitendra Sharma' },
    { name: 'Kriti Singh' }, { name: 'Mahesh Kumar' }, { name: 'Mugdha Sharma' },
    { name: 'Nisha Singh' }, { name: 'Prateek Kumar' }, { name: 'Priyanka Sharma' },
    { name: 'Rajat Singh' }, { name: 'Renu Devi' }, { name: 'Sagarika Sharma' },
    { name: 'Shruti Singh' }, { name: 'Sneha Devi' }, { name: 'Tarun Kumar' },
    { name: 'Usha Sharma' }, { name: 'Vaishali Singh' }, { name: 'Yuvraj Sharma' },
    { name: 'Bhavesh Patel' }, { name: 'Disha Sharma' }, { name: 'Girish Singh' },
    { name: 'Hema Devi' }, { name: 'Karan Kumar' }, { name: 'Kirti Devi' },
    { name: 'Nandini Sharma' }, { name: 'Piyush Singh' }, { name: 'Sakshi Sharma' },
    { name: 'Shilpa Devi' }, { name: 'Suraj Kumar' }, { name: 'Tejas Sharma' },
    { name: 'Vikas Singh' }, { name: 'Yogita Sharma' }, { name: 'Anshul Kumar' },
    { name: 'Bhavna Sharma' }, { name: 'Darshan Singh' }, { name: 'Ekta Devi' },
    { name: 'Gautam Sharma' }, { name: 'Heena Singh' }, { name: 'Jaya Singh' },
    { name: 'Kartik Kumar' }, { name: 'Kishore Sharma' }, { name: 'Lokesh Singh' },
    { name: 'Madhavi Devi' }, { name: 'Niharika Sharma' }, { name: 'Pranjal Singh' },
    { name: 'Rachana Devi' }, { name: 'Saurabh Kumar' }, { name: 'Shivansh Sharma' },
    { name: 'Tanya Singh' }, { name: 'Utkarsha Sharma' }, { name: 'Vidya Devi' },
    { name: 'Yashvi Sharma' },
  ];

  const TIME_UNITS = ['minutes ago', 'hours ago'];

  /**
   * Generates a random time string like "X minutes/hours ago".
   */
  const getRandomTimeAgo = () => {
    const unit = TIME_UNITS[Math.floor(Math.random() * TIME_UNITS.length)];
    let value;
    if (unit === 'minutes ago') {
      value = Math.floor(Math.random() * 55) + 1; // 1 to 55 minutes
    } else {
      value = Math.floor(Math.random() * 23) + 1; // 1 to 23 hours
    }
    return `${value} ${unit}`;
  };

  /**
   * Adds a new notification to the state.
   * @param {string} message - The message to display in the notification.
   */
  const addNotification = (message) => {
    const id = Date.now();
    setNotifications((prevNotifications) => [
      ...prevNotifications,
      { id, message, visible: true },
    ]);

    // Set a timeout to automatically hide the notification
    notificationTimeouts.current[id] = setTimeout(() => {
      setNotifications((prevNotifications) =>
        prevNotifications.map((notif) =>
          notif.id === id ? { ...notif, visible: false } : notif
        )
      );

      // After the fade-out/slide-out transition, remove from DOM
      setTimeout(() => {
        setNotifications((prevNotifications) =>
          prevNotifications.filter((notif) => notif.id !== id)
        );
        // Clean up the specific timeout after the notification is fully removed
        delete notificationTimeouts.current[id];
      }, 500); // Matches CSS transition duration
    }, displayDuration);
  };

  /**
   * Effect hook to automatically generate new notifications.
   */
  useEffect(() => {
    const scheduleNextNotification = () => {
      const randomInterval =
        Math.random() * (maxInterval - minInterval) + minInterval;

      intervalRef.current = setTimeout(() => {
        const randomMember = MEMBERSHIP_DATA[Math.floor(Math.random() * MEMBERSHIP_DATA.length)];
        const timeAgo = getRandomTimeAgo();

        // Messages with bolding using HTML <b> tags, updated to remove specific tiers
        const messages = [
          `${randomMember.name} just purchased a new membership!`,
          `${randomMember.name} just joined, ${timeAgo}.`,
          `New member alert! <b>${randomMember.name}</b> subscribed.`,
          `A new membership was just booked by a new member.`,
          `Welcome, ${randomMember.name}! Thanks for becoming a member.`,
          `Great news! ${randomMember.name} is now a member.`,
          `We're thrilled to have ${randomMember.name} as our newest member!`,
          `Another valued member has joined us: ${randomMember.name}!`,
          `Hooray! ${randomMember.name} just signed up for a membership.`,
          `A big welcome to ${randomMember.name}, our latest subscriber.`,
          `Kudos to ${randomMember.name} for becoming a member!`,
          `Join us in welcoming our newest member, ${randomMember.name}!`,
          `Look who's joined the club! It's ${randomMember.name}.`,
          `We're excited to announce ${randomMember.name} is now a member!`
        ];
        const randomMessage = messages[Math.floor(Math.random() * messages.length)];

        addNotification(randomMessage);
        scheduleNextNotification(); // Schedule the next notification
      }, randomInterval);
    };

    // Start the first notification scheduling
    scheduleNextNotification();

    // Cleanup function
    return () => {
      if (intervalRef.current) {
        clearTimeout(intervalRef.current);
      }
      Object.values(notificationTimeouts.current).forEach(clearTimeout);
    };
  }, [minInterval, maxInterval, displayDuration]); // Re-run effect if props change

  return (
    <>
      <div className="notifications-container">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className={`notification-item ${notification.visible ? 'notification-visible' : ''}`}
          >
            <span style={{ color: '#FFD700', fontSize: '24px', marginRight: '12px' }} className="sparkle-icon">✨</span>
            <span style={{ flexGrow: 1, fontSize: '16px', fontWeight: 500, color: '#333' }} dangerouslySetInnerHTML={{ __html: notification.message }} />
          </div>
        ))}
      </div>

      <style>
        {`
          .notifications-container {
            position: fixed;
            bottom: 16px;
            right: 16px;
            z-index: 1000;
            display: flex;
            flex-direction: column-reverse;
            align-items: flex-end;
            gap: 12px;
            width: calc(100% - 32px);
            max-width: 320px;
            pointer-events: none;
          }

          @media (min-width: 768px) {
            .notifications-container {
              bottom: 32px;
              right: 32px;
              max-width: 384px;
              width: auto;
            }
          }

          .notification-item {
            background-color: #fff;
            color: #333;
            padding: 12px 20px;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border: 1px solid #bae0ff;
            width: 100%;
            display: flex;
            align-items: center;
            cursor: default;
            transition: transform 0.5s ease-out, opacity 0.5s ease-out;
            transform: translateX(100%);
            opacity: 0;
            pointer-events: auto;
          }

          .notification-item.notification-visible {
            transform: translateX(0);
            opacity: 1;
          }

          .notification-item:hover {
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
          }

          .sparkle-icon {
            animation: bounce 1s infinite alternate;
          }

          @keyframes bounce {
            from {
              transform: translateY(0);
            }
            to {
              transform: translateY(-3px);
            }
          }

          body {
            font-family: 'Inter', sans-serif;
          }
        `}
      </style>
    </>
  );
};

export default MembershipNotifications;